module.exports = __webpack_public_path__ + "img/4.b08436f9.png";